import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Mixpanel from 'mixpanel-browser';
import * as VueGoogleMaps from "vue2-google-maps";
import VueCountryCode from "vue-country-code-select";
import CKEditor from 'ckeditor4-vue';
import capitalizeFirst from './filters/capitalizeFirst';
import featureFlags from './plugins/featureFlags';
import { initClientTheme } from './plugins/clientTheme';
import NetworkMonitor from './components/NetworkMonitor.vue';
import appConfig from '@/config/appConfig';
Vue.use(VueCountryCode);
Vue.use(CKEditor);

initClientTheme(store, vuetify);

Vue.component('NetworkMonitor', NetworkMonitor);

 Mixpanel.init('8df32559d3c2fb177fbd18c2982b0494', {
   debug: true
 });

Vue.prototype.$FCM_TOKEN = appConfig.VUE_APP_FCM_TOKEN;

Vue.use(VueGoogleMaps, {
  load: {
    key: appConfig.VUE_APP_GOOGLE_MAP_API_KEY,
    libraries: "places"
  }
});
Vue.use(featureFlags);

Vue.mixin({
  beforeCreate() {
    this.$mixpanel = Mixpanel;
  }
});

Vue.filter('capitalizeFirst', capitalizeFirst);

function onAuthenticatedCallback() {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app');
}

Vue.prototype.$onAuthenticatedCallback = onAuthenticatedCallback;

new Vue({
  router,
  store,
  vuetify,
  async created() {
    await this.$featureFlags.init();
  },
  render: h => h(App)
}).$mount('#app');